export const getNotificationPermission = (windowObj: Window): NotificationPermission =>
    windowObj.Notification?.permission;

export const requestPermission = async (windowObj: Window): Promise<NotificationPermission> =>
    windowObj.Notification?.requestPermission();
